// Routes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LedgerScreen from './Ledger/Ledger'; // Adjust the path as necessary
import { Login } from "./Login/LoginScreen";
import { HomeScreen } from "./HomeScreen";
import { DesignerScreen } from "./Ledger/DesignerScreen";
import { CustomerAgeingLedger } from "./Ledger/CustomerAging/CustomerAging";
import { CustomerLedger } from "./Ledger/CustomerLedger";
import { Order } from "./Order/Order";
import { AllotedOrders } from "./CustomerOrder/AllotedOrders";
import UserProfile from './Profile/UserProfile'; // Import UserProfile
import SaleOrderReport from './Reports/SaleOrderReport';
// import SaleOrderItemReport from './Reports/Report';
import CustomerDetail from './Ledger/CustomerAging/CustomerDetail'; // Import CustomerDetail
import { CreditNote } from "./CreditNoteCreate/CreditNoteCreate";
import { CreditApprove } from "./CreditNoteCreate/CreditNoteApprove";
import { GTStockMovement } from "./Ledger/GTOrderMomentReport/GTOrderMomentReport";
import { GTOrderMove } from "./Ledger/GTOrderMomentReport/GTOrderMove";
import { BranchDayRateReport } from "./Reports/BranchDayRateReport/BranchDayRateReport";
import { RateTrends } from "./Reports/BranchDayRateReport/BranchTrends";
import BranchList from './CompanyListing/BranchList';
import CompanyList from './CompanyListing/CompanyList';
import AllBranch from './CompanyListing/AllBranch';
import CreateOrder from './CustomerOrder/CreateOrder';
import B2CSales from './Ledger/B2CSales/B2CSales';
import B2BSales from './Ledger/B2CSales/B2BSales';

import SaleSummary from './Reports/SaleSummaryReport/SaleSummary';
import SaleWeeklySummary from './Reports/SaleSummaryReport/SaleWeeklySummary';
import SaleWeeklyArea from './Reports/SaleSummaryReport/SaleWeeklyArea';
import DriverList from './DriverCreation/DriverList';
import { RateUpload } from "./RateUpload/RateUpload";
import { PromoCode } from "./PromoCode/Promocode";
import { HorecaUpload } from "./RateUpload/HorecaUpload";
import { EAN } from "./mappingproductimage/MappingImage";

import { Posdayend } from "./Reports/Posdayend/Posdayend";
import { PypReport } from "./Reports/PypReport/PypReport";
import { VanRateReport } from "./Reports/VanRateReport/VanRateReport";
import { HorecaDayRate } from "./Reports/HorecaDayRateReport/HorecaDayRateReport";
import { SaleOrderChangeReport } from "./Reports/SaleOrderRequest/SaleOrderRequestReport";
import { BatchRateUpload } from "./BatchRateUpload/BatchRateUpload";
import { SaleReport } from "./Reports/Laziz/SaleOrder.jsx";
// import { SaleItem } from "./Reports/Laziz/SaleItem.jsx";
import { GTOrderMovementNew } from "./Ledger/GTOrderMomentReport/GTOrderMovementNew.jsx";
import { SaleOrderReportNew } from "./Reports/IndentDemandReport/SaleOrderReportNew.jsx";


// Import Discount Module components
// import DiscountList from './DiscountModule/DiscountList';
// import DiscountModule from './DiscountModule/DiscountModule';
// import DiscountScheduleList from './DiscountModule/DiscountScheduleList';
// import DiscountSchedule from './DiscountModule/DiscountSchedule';
// import QRgenerator from './CompanyListing/QRgenerator';
// import QRcode from './CompanyListing/QRcode';


//New Reports 
import { IndentDemandReport } from "./Reports/IndentDemandReport/IndentDemandReport";
import { TransferOut } from "./Reports/IndentDemandReport/TransferOut";
// import Stock_Cash_EOD from './Reports/IndentDemandReport/Stock_Cash_EOD';
import UploadRateCustomerLookup from './HorecaCustomerRateUpload/HorecaCustomerwise.jsx';
// import UploadRateCustomerLookup from './RateUpload/HorecaAreawisebackup.jsx';
import NearExpiry from './Reports/IndentDemandReport/NearExpiry';
// import JobWorkComponent from './Jobwork/Jobwork';
import WastageReport from './Reports/IndentDemandReport/Wastage';
// import { SubscriptionReport } from "./Reports/IndentDemandReport/SubscriptionReport";
import Stock_EOD from './Reports/IndentDemandReport/Stock_EOD';
import DashBoard from "./Dashboard/Dashboard.jsx";
// import { ImageMappingScreen } from "./mappingproductimage/ImageMapping.jsx";
// import { BillSettlement } from "./BillSettlement/BillSettlement.jsx";
import { HorecaReport } from "./Reports/HorecaReports/HorecaReport.jsx";
import { HorecaAccumulated } from "./Reports/HorecaReports/HorecaAccumulated.jsx";
// import { HorecaMultipleCustomer  } from "./RateUpload/HorecaAreawisebackup.jsx";
// import { HorecaCustomerRateReport  } from "./Reports/HorecaDayRateReport/HorecaCustomerRateReport.jsx";
// import { PaymentReport } from "./Reports/PaymentReport/PaymentReport.jsx";
import { OrderConsolidation } from "./OrderConsolidate/OrderConsolidation.jsx";
// import { DailyRateUpload } from "./RateUpload/DailyRateUpload/DailyRateUpload.jsx";
import { SaleItemDetail } from "./Reports/Laziz/SaleItemDetail.jsx";
import { ItemMasterIndent } from "./OrderConsolidate/ItemMaster/Item_Master_indent.jsx";
import { CustomerWalletLedger } from "./Ledger/CustomerWalletLedger/CustomerWalletLedger.jsx";
import { WalletReportCompact } from "./Ledger/CustomerWalletLedger/WalletPurchases/WalletReportCompact.jsx";
// import { MasterItem } from "./RateUpload/MasterUpload/MasterItem.jsx";
// import { HorecaItemMaster } from "./HorecaItemMaster/HorecaItemMaster.jsx";

import { HorecaUploadPro } from "./RateUpload/HorecaPro.jsx";
import { BomMaster } from "./Masters/BOMMaster/BomMaster.jsx";
import { BomByproduct } from "./Masters/BOMMaster/BomByproduct.jsx";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/HorecaStock" element={<HorecaAccumulated />} />
      {/* <Route path="/HorecaMultipleCustomer" element={<HorecaMultipleCustomer />} />
          <Route path="/HorecaCustomerRateReport" element={<HorecaCustomerRateReport />} /> */}
      <Route path="/WalletReportCompact" element={<WalletReportCompact />} />


      <Route path="/SaleReport" element={<SaleReport />} />
      <Route path="/ItemMasterIndent" element={<ItemMasterIndent />} />

      {/* <Route path="/SaleItem" element={<SaleItem />} /> */}
      <Route path="/GTOrderMovementNew" element={<GTOrderMovementNew />} />
      {/* <Route path="/PaymentReport" element={<PaymentReport />} />   */}
      <Route path="/OrderConsolidation" element={<OrderConsolidation />} />
      {/* <Route path="/DailyRateUpload" element={<DailyRateUpload />} /> */}
      <Route path="/SaleItemDetail" element={<SaleItemDetail />} />

      <Route path="/SaleOrderReport" element={<SaleOrderReport />} />
      <Route path="/HorecaReport" element={<HorecaReport />} />

      {/* <Route path="/SaleOrderItemReport" element={<DiscountList />} /> */}
      {/* <Route path="/Redirect" element={<QRgenerator />} />
       <Route path="/QRcode" element={<QRcode />} /> */}
      <Route path="/BatchRate" element={<BatchRateUpload />} />
      {/* <Route path="/ImageMappingScreen" element={<ImageMappingScreen />} /> */}
      {/* <Route path="/BillSettlement" element={<BillSettlement />} /> */}
      <Route path="/SaleOrderReportNew" element={<SaleOrderReportNew />} />

      {/* <Route path="/SaleOrderReport" element={<DiscountList />} /> */}
      <Route path="/IndentDetailListing" element={<IndentDemandReport />} />
      <Route path="/Transfers" element={<TransferOut />} />
      {/* <Route path="/Stock_Cash_EOD" element={<Stock_Cash_EOD />} /> */}
      <Route path="/HorecaFixRate" element={<UploadRateCustomerLookup />} />
      <Route path="/Near_Expiry" element={<NearExpiry />} />
      {/* <Route path="/JobWorkComponent" element={<JobWorkComponent />} /> */}
      <Route path="/Wastage_Report" element={<WastageReport />} />
      {/* <Route path="/SubscriptionReport" element={<SubscriptionReport />} /> */}
      <Route path="/Stock_EOD" element={<Stock_EOD />} />
      {/* <Route path="/SaleOrderItemReport" element={<DiscountList />} /> */}
      <Route path="/" element={<Navigate to="/Login" />} /> {/* Redirect to Login */}
      <Route path="/CustomerLedger" element={<DesignerScreen />} />
      <Route path="/AgeingLedger" element={<CustomerAgeingLedger />} />
      <Route path="/Home" element={<HomeScreen />} />
      <Route path="/AllotOrder" element={<AllotedOrders />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/balanceledger" element={<CustomerLedger />} />
      <Route path="/ledgerScreen" element={<LedgerScreen />} />
      <Route path="/Order" element={<Order />} />
      <Route path="/sale-weekly-area" element={<SaleWeeklyArea />} />
      <Route path="/GTStockMovement" element={<GTStockMovement />} />
      <Route path="/GTOrderMove" element={<GTOrderMove />} />
      <Route path="/create-order" element={<CreateOrder />} />
      <Route path="/BranchDayRateReport" element={<BranchDayRateReport />} />
      <Route path="/RateTrends" element={<RateTrends />} />
      <Route path="/CreditNoteCreate" element={<CreditNote />} />
      <Route path="/CreditNoteApprove" element={<CreditApprove />} /> {/* UserProfile route */}
      <Route path="/UserProfile" element={<UserProfile />} /> {/* UserProfile route */}
      <Route path="/customer-detail/:customerCode/:fromDate/:toDate/:branchId?" element={<CustomerDetail />} />
      <Route path="/branch-detail" element={<BranchList />} /> {/* CustomerDetail route */}
      <Route path="/company-list" element={<CompanyList />} /> {/* CustomerDetail route */}
      <Route path="/Allbranches" element={<AllBranch />} /> {/* CustomerDetail route */}
      <Route path="/B2CSales" element={<B2CSales />} />
      <Route path="/B2BSales" element={<B2BSales />} />

      <Route path="/SaleSummary" element={<SaleSummary />} />
      <Route path="/SaleWeeklySummary" element={<SaleWeeklySummary />} />
      <Route path="/DriverList" element={<DriverList />} />
      <Route path="/DayRates" element={<RateUpload />} />
      <Route path="/PromoCode" element={<PromoCode />} />
      <Route path="/HORECA" element={<HorecaUpload />} />
      <Route path="/EAN" element={<EAN />} />

      <Route path="/Posdayend" element={<Posdayend />} />
      <Route path="/PYPReport" element={<PypReport />} />
      <Route path="/VANRate" element={<VanRateReport />} />
      <Route path="/HORECARate" element={<HorecaDayRate />} />
      <Route path="/SaleOrderChangeReport" element={<SaleOrderChangeReport />} />
      <Route path="/dashBoard" element={<DashBoard />} />

      <Route path="/CustomerWalletLedger" element={<CustomerWalletLedger />} />MasterItem

      {/* <Route path="/MasterItem" element={<MasterItem />} />
      <Route path="/HorecaItemMaster" element={<HorecaItemMaster />} /> */}

      {/* Add Discount Module Routes */}
      {/* <Route path="/discounts" element={<DiscountList />} />
      <Route path="/discount/new" element={<DiscountModule />} />
      <Route path="/discount/edit/:id" element={<DiscountModule />} />
      <Route path="/discountSchedule" element={<DiscountSchedule />} />
      <Route path="/discountScheduleList" element={<DiscountScheduleList />} />
      <Route path="/discountSchedule/edit/:id" element={<DiscountSchedule />} />
      <Route path="/discountSchedule/new" element={<DiscountSchedule />} />
      <Route path="/discount/view/:id" element={<DiscountModule />} /> */}

      <Route path="/HorecaUploadPro" element={<HorecaUploadPro />} />
      <Route path="/BomMaster" element={<BomMaster />} />
      <Route path="/BomByproduct" element={<BomByproduct />} />

    </Routes>
  );
};

export default AppRoutes;